<c-card *transloco="let t">
    <c-card-body class="px-2">

            <c-row>
              <c-col md="12">
                  <h1>{{ t('Your OK Alone Profile') }}</h1>

                <p *ngIf="monitor" >
                    {{ t('Hello, here are your OK Alone profile settings.', { user: monitor.name }) }}
                </p>

              </c-col>
            </c-row>



          <ng-container *ngIf="monitor">
            <c-row class="justify-content-left">
              <c-col sm="10" lg="6">
                <c-card-group>
                  <c-card>
                    <c-card-body class="px-2">

                        <table
                        [hover]="true"
                        [responsive]="true"
                        [striped]="true"
                        align="middle"
                        cTable
                        class="mb-0 border"
                        >
                        <tbody>
                            <tr>
                                <th>{{ t('Name') }}</th>
                                <td>{{ monitor.name }} </td>
                            </tr>
                            <tr>
                                <th>{{ t('Email') }}</th>
                                <td>{{ monitor.email }} </td>
                            </tr>
                            <tr *ngIf="monitor.phone">
                                <th>{{ t('Phone') }}</th>
                                <td>{{ monitor.phone }} </td>
                            </tr>
                            <tr *ngIf="monitor.phone2">
                                <th>{{ t('Alt Phone') }}</th>
                                <td>{{ monitor.phone2 }} </td>
                            </tr>
                            <tr *ngIf="monitor.timezone">
                                <th>{{ t('Timezone') }}</th>
                                <td>{{ monitor.timezone }}</td>
                            </tr>
                            <tr *ngIf="monitor.country">
                                <th>{{ t('Country') }}</th>
                                <td><img src="https://flagcdn.com/w40/{{monitor.country.toLowerCase()}}.png"></td>
                            </tr>
                            <tr>
                                <th>{{ t('Contact Method') }}</th>
                                <td>{{monitor.contact.join(", ")}}</td>
                            </tr>
                        </tbody>
                        </table>
                        <br/>
                        <button *ngIf="okService.isAdmin()" cButton class="px-4 text-white btn-info"  routerLink="/mgmt/monitor/{{monitor_id}}">
                          <svg cIcon  name="cil-pencil"></svg> {{ t('Edit Your Profile') }}
                        </button>
                        <div *ngIf="!okService.isAdmin()" role="alert" class="alert alert-warning alert-dismissible fade show text-center">
                          <p>{{ t('If you need to update this information please ask an admin from your company to update your account.') }}</p>
                        </div>

                    </c-card-body>
                  </c-card>
                </c-card-group>
              </c-col>

                <c-col sm="10" lg="6">
                  <div class="card" *ngIf="!okService.isAdp()">
                    <div class="card-header">
                      {{ t('Update Your Password') }}
                    </div>
                    <div class="card-body">



                      <ng-container *ngIf="okService.session.password_change_due">

                        <div class="alert alert-warning" role="alert">
                          <b>{{ t('It\'s time to change your password') }}</b> {{ t('Please change your password now') }}
                        </div>
                  
                      </ng-container>


                      <form [formGroup]="passFormGroup" cForm (ngSubmit)="submitPassForm()">


                        <c-input-group class="mb-3">
                          <span cInputGroupText>
                            <svg cIcon name="cilLockLocked"></svg>
                          </span>
                          <input
                            [formControlName]="'password'"
                            cFormControl
                            placeholder="{{ t('New Password') }}"
                            [ngClass]="{ 'border-danger': passSubmitted && pf['password'].errors }"
                          />
                          <div *ngIf="passSubmitted && pf['password'].errors" class="invalid-feedback">
                            {{ t('Password should be at least 8 characters in length and should include at least one upper case letter, one number, and one special character. The password should not be the same as the existing password.') }}
                          </div>
                        </c-input-group>
                        <c-row>
                          <c-col xs="12">
                            <p>Password should be at least 8 characters in length and should include at least one upper case letter, one number, and one special character.</p>
                            <button cButton class="px-4 text-white btn-info" type="submit">
                              <svg cIcon  name="cil-check"></svg> {{ t('Update Your Password') }}
                            </button>
                          </c-col>
                        </c-row>
                      </form>
                    </div>
                  </div>
                </c-col>
            </c-row>

          </ng-container>


    </c-card-body>
  </c-card>


